import React from "react";

export default function TableItem({
  AppleSMSFix,
  handleEdit,
  handleDelete,
}) {
  function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
  }

  return (
    <tr key={AppleSMSFix.id}>
      <td className="id" style={{ display: "none" }}>
        {AppleSMSFix.id}
      </td>
      <td className="customer_name">{AppleSMSFix.id}</td>
      <td className="email">{AppleSMSFix.email}</td>
      <td className="phone">{AppleSMSFix.phone || "-"}</td>
      <td className="date">{timeSince(new Date(AppleSMSFix.created_at))}</td>
      <td>
        <div className="d-flex gap-2">
          <div className="edit">
            <button
              className="btn btn-md btn-success edit-item-btn"
              onClick={() => handleEdit(AppleSMSFix)}
            >
              <i className="ri-edit-line align-bottom"></i>
            </button>
          </div>
          <div className="remove">
            <button
              className="btn btn-danger btn-md remove-item-btn"
              onClick={() => handleDelete(AppleSMSFix.id)}
            >
              <i class="ri-delete-bin-6-line align-bottom"></i>
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
}
